import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Action from '../action';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../../../messages';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import RelatedLinksActionIcon from './related-links-action-icon';
const ViewRelatedLinksAction = props => {
  var _context$actions;
  const context = useFlexibleUiContext();
  const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.ViewRelatedLinksAction;
  return actionData ? jsx(Action, _extends({
    content: jsx(FormattedMessage, messages.related_links_view_related_urls),
    icon: jsx(RelatedLinksActionIcon, null),
    testId: "smart-action-view-related-links-action",
    ariaLabel: "View most recent pages or content types coming from or found on this link"
  }, props)) : null;
};
export default ViewRelatedLinksAction;